import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { PATH } from '../../../../constants/path';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../../constants/cookie';
import { CONTEXT_ROOT, FAQ_ID_ELIGIBILITY, STATIC_ROOT } from '../../../../constants';

import {
    getFnacLoginUrl,
    getDartyLoginUrl,
    extractRedirectParam,
    toSameOriginUrl
} from '../../../../utils/ssoUtil';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import HeadComponent from '../../../HeadComponent';
import Breadcrumb from '../../../breadcrumb/Breadcrumb';
import LoginBlockComponent from './LoginBlockComponent';
import LimitedAccessComponent from './LimitedAccessComponent';
import { withTemplate } from '../../../template/withTemplate';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { PrimaryTemplate } from '../../../template/PrimaryTemplate';
import LoginErrorModalTrigger from '../../../authentication/loginerror/LoginErrorModalTrigger';

import './LoginChoicePageStyle.scss';

const LoginChoicePage = ({ i18n, show, limited, redirectUrl }) => {
    useEffect(() => {
        if (redirectUrl) {
            sessionStorage.setItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN, redirectUrl);
        }
    }, [redirectUrl]);

    const showFnac = show !== 'darty';
    const showDarty = show !== 'fnac';
    const singleBlock = show === 'fnac' || show === 'darty';

    return (
        <main role="main" className="conteneur conteneur-mobile" id="p-login-choice">
            <HeadComponent
                title={i18n.TITLE}
                description={i18n.DESCRIPTION}
                canonicalLink={`${CONTEXT_ROOT}${PATH.LOGIN_PATH}`}
            />
            <Breadcrumb
                defaultRoute
                routes={[
                    {
                        label: i18n.BREADCRUMB,
                        route: PATH.LOGIN_PATH
                    }
                ]}
            />

            <h1>{i18n.TITLE}</h1>

            <LoginErrorModalTrigger />

            {limited ? (
                <LimitedAccessComponent />
            ) : (
                <React.Fragment>
                    {singleBlock && (
                        <p className="eligibilityMessage">
                            {convertHtmlToReactDomWithParams(
                                show === 'fnac'
                                    ? i18n.FNAC_ELIGIBLE_MESSAGE
                                    : i18n.DARTY_ELIGIBLE_MESSAGE
                            )}
                        </p>
                    )}

                    <div className="mainContainer">
                        {showFnac && (
                            <LoginBlockComponent
                                variant="fnac"
                                logoSrc={`${STATIC_ROOT}/logo-fnac.png`}
                                externalUrl={getFnacLoginUrl()}
                            />
                        )}

                        {showDarty && (
                            <LoginBlockComponent
                                variant="darty"
                                logoSrc={`${STATIC_ROOT}/logo-darty.png`}
                                externalUrl={getDartyLoginUrl()}
                            />
                        )}
                    </div>

                    <div className="faqLink">
                        <LocalizedNavLink
                            to={`${PATH.FAQ_PATH}${
                                FAQ_ID_ELIGIBILITY ? `#${FAQ_ID_ELIGIBILITY}` : ''
                            }`}
                            title={i18n.FAQ_LINK}>
                            {i18n.FAQ_LINK}
                        </LocalizedNavLink>
                    </div>
                </React.Fragment>
            )}
        </main>
    );
};

const mapStateToProps = (state, ownProps) => {
    const params = queryString.parse(ownProps.location.search);

    return {
        i18n: state.i18n.page.AUTHENTICATION,
        show: params.show,
        limited: params.limited === '1',
        redirectUrl: toSameOriginUrl(extractRedirectParam(ownProps.location.search))
    };
};

export default withTemplate(connect(mapStateToProps)(LoginChoicePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/authentication/login-choice/LoginChoicePage.js